<template>
  <div v-if="isFooter">
    <v-runtime-template :template="includeTempFooter"/>
  </div>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import SurveyPopup from '~pages/contents/main/SurveyPopup.vue'

export default {
  name: 'WepFooter',
  components: {
    VRuntimeTemplate,
    SurveyPopup
  },
  props: {
    isFooter: {
      type: Boolean,
      default: true
    },
    isContact: { // SUBDEV-333 isContact 추가
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      includeFooterHtml: '',
      includeCommonLayoutHtml: '',
      basePath: this.getStore('mmpAuth').state.basePath,
      policyPopupShow: false,
      policyNum: '',
      options: {
        height: '100%',
        color: '#ccc',
        opacity: 1,
        size: '.6rem',
        distance: '1rem',
        disableFadeOut: true,
        alwaysVisible: true
      },
      layoutTitle: '',
      includeLayoutHtml: '',
      wepApcId: this.getStore('mmpAuth').state.session.userId,
      wepSets: this.getStore('mmpAuth').state.wepSets
    }
  },
  computed: {
    includeTempFooter () {
      return this.includeFooterHtml
    },
    includeCommonLayout () {
      return this.includeCommonLayoutHtml
    }
  },
  watch: {
    // 'includeTempFooter': {
    //   handler: function (nVal, oVal) {
    //     // console.log('watch includeTempFooter')
    //   }
    // },
    // 'includeTempPolicy': {
    //   handler: function (nVal, oVal) {
    //     // console.log('watch includeTempFooter')
    //   }
    // }
  },
  async created () {
    this.getEmptyTemplate()
  },
  methods: {
    getEmptyTemplate () {
      let resourceFooterUrl = ''
      resourceFooterUrl = this.getTemplatePath('wepFooter.html')
      this.$http.loadRes(resourceFooterUrl).then( (res) => {
        this.includeFooterHtml = res
      })
    },
    getLayoutPopup (obj) {
      let param = {'policyNum': obj}
      this.$popup.WepPolicyModal(this.$el, param)
    },
    async fnSatisfaction () {
      let tokenStore = window.vue.getStore('token')
      let rootStore = window.vue.getStore('root')
      this.isInquiry = false
      let params = {
        wepId: this.getStore('mmpAuth').state.saveId,
        langId: localStorage.getItem('language')
      }
      let resultInfo = await this.$http.mmp.getTzTime(this, params)
      let currDay = resultInfo.data.data
      if (currDay >= this.wepSets.videoTrnsStartDtm && currDay <= this.wepSets.videoTrnsEndDtm) {
        if (rootStore !== null && rootStore.getters.getSession.authenticated && tokenStore.getters.getTokenAuth) {
          // 평가유무 확인
          let params = {
            survyScCd: '02',
            wepApcId: this.wepApcId
          }
          let resultInfo = await this.$http.mmp.evalSurveyYn(this, params)
          if (resultInfo.data.status !== 'OK') {
            this.commAlert(this.$t('WEP00027'))
          } else {
            if (resultInfo.data.data.evalYn === 'N') {
              let param = {'isInquiry': false}
              this.$popup.WepSurveyModal(this.$el, param)
            } else {
              this.commAlert(this.$t('WEP00026'))
            }
          }
        } else {
          this.getTemplate('wepOnAir.html', '0', 'onAir')
        }
      } else {
        this.commAlert(this.$t('WEP00019'))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/layouts/WepFooter.vue